import React from 'react';
import { Flex, Divider, Form, Empty, Input, message, Button, Space } from 'antd';
import SwitchShop from '../shop/switch-shop';
import { getCurrentShopId } from '../shop/get-current-shop';

export default () => { 
    const [shopId, setShopId] = React.useState(null);
    const [form] = Form.useForm();

    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setShopId(id);
        };
        
        fetchShopId();
    }, []);
    
    React.useEffect(() => {
        if (shopId) {
            getConfig().then(res => {
                // setConfig(res);
                if(res?.success) {
                    initForm(res.data);
                }
            });
        }
    }, [shopId]);

    const onSubmit = async () => {
        const values = await form.validateFields();
        console.log('values', values);

        await updateConfig(values);
    }

    const initForm = (config) => {
        form.setFieldsValue(config);
    }

    const getConfig = async () => {
        if (!shopId) return;
        
        const res = await fetch(`/api/order/notify-setting/get?shopId=${shopId}`);
        const result = await res.json();

        if (result.success) {
            form.setFieldsValue(result.data);
        }
    }

    const updateConfig = async (values) => {
        if (!shopId) return;
        
        const res = await fetch(`/api/order/notify-setting/update?shopId=${shopId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(values)
        }); 

        const result = await res.json();

        if(result && result.success) {
            message.success('保存成功');
        } else {
            message.error(result.data);
        }
    }

    return (
        <>
            <SwitchShop />
            
            <h2 className="admin-page-title">通知设置</h2>
            
            <div className="admin-form-container">
                <Form form={form} layout="vertical">
                    <Form.Item 
                        label="企业微信机器人链接"
                        name="qywxBotUrl"
                    >
                        <Input className="admin-form-input" placeholder="请输入企业微信机器人链接" />
                    </Form.Item>
                    <Form.Item 
                        label="手机号码"
                        name="phoneNos"
                        help="多个手机号码用英文逗号隔开"
                    >
                        <Input className="admin-form-input" placeholder="请输入手机号码，多个用英文逗号隔开" />
                    </Form.Item>
                    
                    <div className="admin-form-actions">
                        <Button href='/order'>返回</Button>
                        <Button type="primary" onClick={onSubmit}>保存</Button>
                    </div>
                </Form>
            </div>
        </>
    )
};